import styled, { css } from 'styled-components';

import {
  breakpoints,
  ColorRectangle,
  IBasicStyledProps,
  theme,
} from '@notino/react-styleguide';

export const Container = styled.div<{ newDesign: boolean }>`
  width: 100%;

  ${({ newDesign }) =>
    !newDesign &&
    css`
      margin-bottom: 0.625rem;
    `}
`;

export const VariantsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

interface IVariantProps extends IBasicStyledProps {
  isSelected: boolean;
  isOnStock: boolean;
  touch: boolean;
  newDesign: boolean;
}

export const Variant = styled.div<IVariantProps>`
  position: relative;

  ${({ newDesign, isSelected }) => css`
    border: ${newDesign ? '2px' : '1px'} solid
      ${isSelected ? theme.color.common.gray30 : theme.color.common.white};
  `}

  cursor: pointer;

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin: 0;
        `
      : css`
          margin: 0 0.3125rem 0.3125rem 0;
        `}

  display: ${(props: IVariantProps) => (props.touch ? 'flex' : 'none')};
  @media (hover: hover) {
    display: ${(props: IVariantProps) => (props.touch ? 'none' : 'flex')};
  }
`;

export const StyledColorRectangle = styled(ColorRectangle)<{
  newDesign: boolean;
  bordered?: boolean;
}>`
  ${({ bordered }) =>
    bordered &&
    css`
      border: 1px solid ${theme.color.common.gray30} !important;
    `}

  ${({ newDesign }) =>
    newDesign
      ? css`
          width: 2.5rem;
          height: 2.5rem;
          margin: 0.25em;
          @media (min-width: ${breakpoints.lg}) {
            width: 2rem;
            height: 2rem;
          }
        `
      : css``}
`;
